import { Button } from "@faire/slate/components/button";
import { SelectionCardGroup } from "@faire/slate/components/selection-card";
import { useState } from "react";

import {
  PREPACK_PARTIAL_RESOLUTION_COPY,
  type PrePackAllItemsAffected,
} from "./prePackPolicyData";
import { RetailerMobileNav } from "./RetailerMobileNav";

type ResolutionOption = "replace" | "refund";

type PrePackResolutionScreenProps = {
  allItemsAffected: PrePackAllItemsAffected;
  onBack?: () => void;
  onContinue?: () => void;
};

export const PrePackResolutionScreen = ({
  allItemsAffected,
  onBack,
  onContinue,
}: PrePackResolutionScreenProps) => {
  const isWholePrepackAffected = allItemsAffected === "yes";
  const [resolution, setResolution] = useState<ResolutionOption>(
    isWholePrepackAffected ? "replace" : "refund"
  );

  return (
    <div className="bg-fs-surface-primary flex min-h-full flex-col">
      <RetailerMobileNav progressFraction={0.5} onBack={onBack} />
      <div className="flex flex-1 flex-col px-(--slate-spacing-section-medium) pt-(--slate-spacing-section-medium) pb-(--slate-spacing-section-large)">
        {isWholePrepackAffected ? (
          <>
            <h1 className="type-fs-page-heading text-fs-text-primary mb-(--slate-dimensions-4)">
              How would you like to resolve this?
            </h1>
            <div className="flex flex-col gap-(--slate-dimensions-2)">
              <SelectionCardGroup
                name="prepack-retailer-resolution"
                items={[
                  {
                    label: "Replace items",
                    description:
                      "A replacement order will be sent once accepted by the brand",
                    checked: resolution === "replace",
                    onChange: () => setResolution("replace"),
                  },
                  {
                    label: "Get a refund",
                    description:
                      "Affected items will be removed from your invoice",
                    checked: resolution === "refund",
                    onChange: () => setResolution("refund"),
                  },
                ]}
              />
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col gap-(--slate-dimensions-2)">
              <h1 className="type-fs-page-heading text-fs-text-primary">
                Resolution for this issue
              </h1>
              <p className="type-fs-paragraph text-fs-text-primary mb-(--slate-dimensions-4)">
                {PREPACK_PARTIAL_RESOLUTION_COPY}
              </p>
            </div>
            <div className="flex flex-col gap-(--slate-dimensions-2)">
              <SelectionCardGroup
                name="prepack-partial-resolution"
                items={[
                  {
                    label: "Replacement not available",
                    checked: false,
                    disabled: true,
                    onChange: () => undefined,
                  },
                  {
                    label: "Get a refund",
                    description:
                      "Affected items will be removed from your invoice",
                    checked: resolution === "refund",
                    onChange: () => setResolution("refund"),
                  },
                ]}
              />
            </div>
          </>
        )}
      </div>
      <div className="bg-fs-surface-primary sticky bottom-0 px-(--slate-spacing-section-medium) pt-(--slate-dimensions-2) pb-(--slate-spacing-section-medium)">
        <Button fullWidth onClick={onContinue} variant="primary">
          Continue
        </Button>
      </div>
    </div>
  );
};
